import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import RouteSetup from "./routes/RouteSetup";
import { createRoot } from "react-dom/client";
import "./api/firebase";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "firebaseui/dist/firebaseui.css";

// Context Providers
import { HistoryProvider } from "./contexts/HistoryContext";
import { AudioPlayingProvider } from "./contexts/AudioPlayingContext";
import { InterviewProvider } from "./contexts/InterviewContext";
import { AuthProvider } from "./contexts/AuthContext";
import { LoadingProvider } from "./contexts/LoadingContext";
import { MediaPermissionProvider } from "./contexts/MediaPermissionContext";
import { NotificationProvider } from "./contexts/NotificationContext";

// Components
import LoadingOverlay from "./pages/LoadingOverlay";
import NotificationPopup from "./components/NotificationPopup";

// import { GoogleOAuthProvider } from "@react-oauth/google";
const queryClient = new QueryClient();

// Define the main App component
function App() {
  // Calculate scrollbar width on component mount
  useEffect(() => {
    // Create a temporary div to measure scrollbar width
    const scrollDiv = document.createElement("div");
    scrollDiv.style.cssText =
      "width: 100px; height: 100px; overflow: scroll; position: absolute; top: -9999px;";
    document.body.appendChild(scrollDiv);

    // Calculate scrollbar width
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);

    // Clean up
    document.body.removeChild(scrollDiv);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/dashboard">
        <LoadingProvider>
          <MediaPermissionProvider>
            <AuthProvider>
              <NotificationProvider>
                <AudioPlayingProvider>
                  <InterviewProvider>
                    <HistoryProvider>
                      <LoadingOverlay />
                      <NotificationPopup />
                      <RouteSetup />
                    </HistoryProvider>
                  </InterviewProvider>
                </AudioPlayingProvider>
              </NotificationProvider>
            </AuthProvider>
          </MediaPermissionProvider>
        </LoadingProvider>
      </BrowserRouter>
    </QueryClientProvider>
    // </GoogleOAuthProvider>
  );
}

// Create a root element and render the component
const container = document.createElement("div");
document.body.appendChild(container);
const root = createRoot(container);

export default App;
